<template>
    <!--短攻略-->
    <div class="short-list-item" :style="{ 'background': mBackground(8.1, 'bottom') }">
        <!--用户信息-->
        <div class="row row-center user-banner">
            <igc-user :item="item"></igc-user>

            <!--删除-->
            <div class="col"></div>
            <div class="user_delete no-flex" :style="{ 'color': mColor(3) }" @click="isShortPopup = true" v-if="item.is_my">
                <div class="row row-center delete_inner">
                    <sui-icon :fill="mColor(2.1)" class="ig--icon" name="trash"></sui-icon>
                    删除
                </div>
            </div>
        </div>

        <!--文字-->
        <router-link :to="`/detail/short/${item.guide_id}`"
            v-dmp="{action:'click,pop', targetid: item.iId, targettype: 'moment', title: item.sTitle, from: 'ingame'}"
            tag="div" class="ig--content-text ig-style--ellipsis-2" :style="{ 'color': mColor(1) }">{{ item.guide_content | igDecodeUnicode }}</router-link>

        <!--标签-->
        <div class="content-bottom row row-center">
            <!-- <div class="bottom-button button-like row" @click="vote(1)" :style="{'background-color': color['10'], color: item.vote_info==1 ? color['4'] : color['3']}">
                <sui-icon :fill="rgba(color['2'], 0.65)" class="ig--icon" name="arrow-dropup"></sui-icon>
                <div class="like-text no-flex">赞同</div>
                <div class="like-num no-flex" v-text="item.approval_num"></div>
            </div>

            <div class="bottom-button button-dislike" @click="vote(2, )" :style="{'background-color': color['10'], color: item.vote_info==1 ? color['4'] : color['3']}">
                <sui-icon :fill="rgba(color['2'], 0.65)" class="ig--icon" name="arrow-dropbottom"></sui-icon>
            </div> -->

            <igc-like :item.sync="item" >
                <sui-icon class="ig--icon comment-icon"
                    name="message-outline"
                    :fill="mColor(3)"></sui-icon>
                <div class="ig--text comment-num"
                    v-if="item.igNum"
                    :style="{ 'color': mColor(3) }">{{ (item.igNum && item.igNum.comment)||0 }}</div>
                <div class="ig--text comment-num"
                    v-else
                    :style="{ 'color': mColor(3) }">0</div>
            </igc-like>

            <div class="col"></div>
            <div class="text-right">
                <div class="content-tag row">
                    <!-- <div class="ig--content-desc row row-center">
                        <div class="desc-name" :style="{ 'background-color': rgba(color['2'], 0.65), 'color': color['3'] }">
                            对<span class="name-author" :style="{ 'color': color['11'] }">春野樱</span>的短攻略
                        </div>
                    </div> -->
                    <igc-item-tag :item="item" v-if="!notag"></igc-item-tag>
                </div>
            </div>
        </div>

        <igc-popup :config="shortPopup" :show="isShortPopup" @cancel="cancelShort" @confirm="deleteShort">
            <div class="pop-content">
                <div class="shortPopup text-center" :style="{ 'color': mColor(1) }">确定删除此评论吗</div>
            </div>
        </igc-popup>
    </div>
</template>
<script>
import mCore from '../../scripts/mixins/core'
import { requestJsonp } from '../../scripts/request'
import IgcPopup from '../../components/popup/popup.vue'
import IgcLike from '../../components/like-dislike/index.vue'
import IgcUser from '../../components/item-user/index.vue'
import IgcItemTag from '../../components/item-tag/index.vue'
export default {
    name: 'igc-item-short',

    mixins: [mCore],

    data() {
        return {
            // 删除弹框
            isShortPopup: false,
            shortPopup: {

            }
        }
    },

    props: {
        item: {
            type: Object,
            required: true
        },

        notag: {
            type: Boolean,
            require: false
        }
    },

    methods: {
        deleteShort() {
            let that = this;
            let item = this.item;
            this.isShortPopup = false;
            requestJsonp({
                url: '/interactcenter/del_tiny_guide.php',
                data: {
                    guide_id: that.item.guide_id
                }
            }).then(result => {
                if (result.status.toLowerCase() == 'success') {
                    this.$toast('删除成功')
                    that.$emit('delete-item', item)
                }
            })
        },
        cancelShort() {
            this.isShortPopup = false;
        }
    },
    components: {
        IgcPopup,
        IgcLike,
        IgcUser,
        IgcItemTag
    }
}
</script>


<style lang="postcss">
.short-list-item {
    overflow: hidden;
    padding: 24px;
    /* border-bottom: solid 1px; */
    .ig--content-user {
        margin-bottom: 16px;
    }
    .item-image {
        width: 210px;
        height: 140px;
        margin-right: 30px;
        border-radius: 5px;
    }
    .item-info {
        .info-text {
            font-size: 32px;
            line-height: 1;
            box-sizing: border-box;
            margin-bottom: 20px;
        }
        .info-tag {
            font-size: 22px;
            border-radius: 16px;
            line-height: 1.545;
            margin-right: 22px;
            background: #ccc;
            padding: 0 16px;
        }
        .info-view {
            font-size: 24px;
            .ig--icon {
                width: 22px;
                margin-right: 8px;
            }
        }
    }
    .ig--content-text {
        /* margin-left: 75px; */
        height: 76px;
        margin-bottom: 30px
    }
    .ig--content-desc {
        margin-top: 0;
    }
    .content-bottom {
        .ig--content-desc {
            margin-top: 0;
        }
        .comment-icon {
            width: 36px;
            height: 36px;
            margin-right: 4px;
            margin-left: 24px;
        }
        .comment-num {
            margin-right: 24px;
            font-size: 24px;
        }
    }
    .shortPopup {
        font-size: 38px;
    }
}

.user-banner {
    .user_delete {
        font-size: 24px;
        .ig--icon {
            width: 28px;
            margin-right: 10px;
        }
    }
}


/* 公用文本样式 */
.ig--content-text {
    padding-top: 17px;
    font-size: 26px;
    line-height: 1.538;
    height: 155px;
    box-sizing: content-box;

    .text-image {
        flex: none;
        width: 210px;
        height: 140px;
        border-radius: 4px;
        margin-right: 24px;
    }
    .text-desc {
        font-size: 32px;
        line-height: 1.375;
        height: 135px;
    }
}


/* 公用标签样式 */
.ig--content-desc {
    font-size: 24px;
    margin-top: 16px;
    .desc-name{
        padding: 10px 30px;
        background: #ccc;
        border-radius: 22px;
        .name-author{
            margin: 0 8px;
        }
    }
}
</style>
